import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <Box>
      <Typography variant="h3" gutterBottom className="vintage-script-header">
        Privacy Policy
      </Typography>
      
      <Paper sx={{
        p: 3,
        background: 'transparent',
        border: '2px solid var(--color-border-vintage)',
        borderRadius: 0,
        boxShadow: 'none',
        position: 'relative',
        mb: 3
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, var(--color-accent-gold) 0%, transparent 50%, var(--color-accent-gold) 100%)'
        }}></div>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6,
          mt: 2
        }}>
          At Agritur, we are committed to protecting your privacy and ensuring the security 
          of your personal information. This Privacy Policy explains how we collect, use, 
          and safeguard your data when you use our garden management platform.
        </Typography>
        
        <Typography variant="h6" sx={{
          fontFamily: 'var(--font-decorative)',
          color: 'var(--color-sepia)',
          mt: 3,
          mb: 1
        }}>
          Information We Collect
        </Typography>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6
        }}>
          We collect information you provide directly to us, such as when you create an account, 
          add garden information, or contact us for support. This may include your name, email 
          address, garden details, and crop information.
        </Typography>
        
        <Typography variant="h6" sx={{
          fontFamily: 'var(--font-decorative)',
          color: 'var(--color-sepia)',
          mt: 3,
          mb: 1
        }}>
          How We Use Your Information
        </Typography>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6
        }}>
          We use your information to provide and improve our services, personalize your 
          gardening experience, and communicate with you about your account and our services. 
          We do not sell or share your personal information with third parties without your consent.
        </Typography>
        
        <Typography variant="h6" sx={{
          fontFamily: 'var(--font-decorative)',
          color: 'var(--color-sepia)',
          mt: 3,
          mb: 1
        }}>
          Data Security
        </Typography>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6
        }}>
          We implement appropriate security measures to protect your personal information 
          against unauthorized access, alteration, disclosure, or destruction. However, 
          no method of transmission over the internet is 100% secure.
        </Typography>
        
        <Typography variant="h6" sx={{
          fontFamily: 'var(--font-decorative)',
          color: 'var(--color-sepia)',
          mt: 3,
          mb: 1
        }}>
          Contact Us
        </Typography>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6
        }}>
          If you have any questions about this Privacy Policy or our data practices, 
          please contact us through the application or via email.
        </Typography>
        
        <Typography variant="body2" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-sepia)',
          mt: 3,
          fontStyle: 'italic'
        }}>
          Last updated: {new Date().toLocaleDateString()}
        </Typography>
      </Paper>
    </Box>
  );
};

export default PrivacyPolicy;
